import React, { useState, useEffect, useContext } from 'react';
import AdminNav from '../adminNav';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import EditIcon from '@mui/icons-material/Edit';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import SaveIcon from '@mui/icons-material/Save';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import axios from 'axios';
import { validateWhatsAppNumber, normalizeSubscriptionPlan, isProSubscription } from '../../../utils/whatsappOrder';
import { userContext } from '../../../contexts/userContext';  
import { useParams, useNavigate } from 'react-router-dom';

const EditResturnt = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { userType, userId } = useContext(userContext);
  const [loading, setLoading] = useState(true);
  const [resturentName, setResturentName] = useState('');
  const [resturentNameAr, setResturentNameAr] = useState('');
  const [resturentImageFile, setResturentImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState('');
  const [existingImageUrl, setExistingImageUrl] = useState('');
  const [menuLanguage, setMenuLanguage] = useState('en'); // 'en' | 'ar' | 'both'
  const isBilingual = menuLanguage === 'both';
  const showArabic = menuLanguage === 'ar' || menuLanguage === 'both';
  const isArabicOnly = menuLanguage === 'ar';
  const [location, setLocation] = useState('');
  const [locationLink, setLocationLink] = useState('');
  const [locationLabel, setLocationLabel] = useState('');
  const [locationLabelAr, setLocationLabelAr] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [currency, setCurrency] = useState('');
  const [taxPercentage, setTaxPercentage] = useState('');
  const [servicePercentage, setServicePercentage] = useState('');
  const [expireDate, setExpireDate] = useState('');
  const [facebookLink, setFacebookLink] = useState('');
  const [instagramLink, setInstagramLink] = useState('');
  const [googleReviewLink, setGoogleReviewLink] = useState('');
  const [whatsappLink, setWhatsappLink] = useState('');
  const [whatsappNumber, setWhatsappNumber] = useState('');
  const [subscriptionPlan, setSubscriptionPlan] = useState('Starter');
  const [primaryColor, setPrimaryColor] = useState('#ec4913');
  const [backgroundColor, setBackgroundColor] = useState('#1a1410');
  const [usersType4, setUsersType4] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState('');
  const [categories, setCategories] = useState([]);
  const [expandedCatIndex, setExpandedCatIndex] = useState(null);
  const [expandedSubIndex, setExpandedSubIndex] = useState(null);
  const [saveMessage, setSaveMessage] = useState('');
  const [saveError, setSaveError] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  // Category form
  const [categoryName, setCategoryName] = useState('');
  const [categoryNameAr, setCategoryNameAr] = useState('');

  // Subcategory form
  const [subCategoryName, setSubCategoryName] = useState('');
  const [subCategoryNameAr, setSubCategoryNameAr] = useState('');

  // Item form (title, description, price only)
  const [itemTitle, setItemTitle] = useState('');
  const [itemTitleAr, setItemTitleAr] = useState('');
  const [itemDesc, setItemDesc] = useState('');
  const [itemDescAr, setItemDescAr] = useState('');
  const [itemPrice, setItemPrice] = useState('');

  // Edit dialogs state
  const [editCategoryDialog, setEditCategoryDialog] = useState(false);
  const [editSubDialog, setEditSubDialog] = useState(false);
  const [editItemDialog, setEditItemDialog] = useState(false);
  
  // Edit indices
  const [editingCatIndex, setEditingCatIndex] = useState(null);
  const [editingSubIndex, setEditingSubIndex] = useState(null);
  const [editingItemIndex, setEditingItemIndex] = useState(null);
  
  // Edit form values
  const [editCategoryName, setEditCategoryName] = useState('');
  const [editCategoryNameAr, setEditCategoryNameAr] = useState('');
  const [editSubCategoryName, setEditSubCategoryName] = useState('');
  const [editSubCategoryNameAr, setEditSubCategoryNameAr] = useState('');
  const [editItemTitle, setEditItemTitle] = useState('');
  const [editItemTitleAr, setEditItemTitleAr] = useState('');
  const [editItemDesc, setEditItemDesc] = useState('');
  const [editItemDescAr, setEditItemDescAr] = useState('');
  const [editItemPrice, setEditItemPrice] = useState('');

  // Load restaurant data
  useEffect(() => {
    const token = localStorage.getItem('auth-token');
    setLoading(true);
    axios
      .get(`/getResturent/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setResturentName(res.data.resturentName || '');
        setResturentNameAr(res.data.resturentNameAr || '');
        setMenuLanguage(res.data.menuLanguage || (res.data.isBilingual ? 'both' : 'en'));
        setCategories(res.data.categories || []);
        const imgUrl = res.data.resturentImage || '';
        setExistingImageUrl(imgUrl);
        setImagePreview(imgUrl);
        setLocation(res.data.location || '');
        setLocationLink(res.data.locationLink || '');
        setLocationLabel(res.data.locationLabel || '');
        setLocationLabelAr(res.data.locationLabelAr || '');
        setPhoneNumber(res.data.phoneNumber || '');
        setCurrency(res.data.currency || '');
        setTaxPercentage(
          res.data.taxPercentage !== undefined && res.data.taxPercentage !== null
            ? String(res.data.taxPercentage)
            : ''
        );
        setServicePercentage(
          res.data.servicePercentage !== undefined && res.data.servicePercentage !== null
            ? String(res.data.servicePercentage)
            : ''
        );
        setExpireDate(res.data.expireDate ? new Date(res.data.expireDate).toISOString().split('T')[0] : '');
        setFacebookLink(res.data.facebookLink || '');
        setInstagramLink(res.data.instagramLink || '');
        setGoogleReviewLink(res.data.googleReviewLink || '');
        setWhatsappLink(res.data.whatsappLink || '');
        setWhatsappNumber(res.data.whatsappNumber || '');
        setSubscriptionPlan(normalizeSubscriptionPlan(res.data.subscriptionPlan));
        setPrimaryColor(res.data.primaryColor || '#ec4913');
        setBackgroundColor(res.data.backgroundColor || '#1a1410');
        setSelectedUserId(res.data.userId || '');
        setLoading(false);
      })
      .catch((err) => {
        setSaveError('Failed to load restaurant data');
        setLoading(false);
      });
  }, [id]);

  // Fetch users with userType === 4 for the select dropdown
  useEffect(() => {
    const token = localStorage.getItem('auth-token');
    axios
      .post('/getUsers', { type: 4 }, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        setUsersType4(res.data.Users || []);
      })
      .catch(() => {
        setUsersType4([]);
      });
  }, []);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setResturentImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const removeImage = () => {
    setResturentImageFile(null);
    setImagePreview(existingImageUrl);
  };

  const handleCategoryImageChange = (catIndex, e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const updated = [...categories];
    if (!updated[catIndex]) return;
    updated[catIndex] = { ...updated[catIndex], imageFile: file, categoryImage: URL.createObjectURL(file) };
    setCategories(updated);
  };

  const removeCategoryImage = (catIndex) => {
    const updated = [...categories];
    if (!updated[catIndex]) return;
    if (updated[catIndex].categoryImage && updated[catIndex].categoryImage.startsWith('blob:')) URL.revokeObjectURL(updated[catIndex].categoryImage);
    updated[catIndex] = { ...updated[catIndex], imageFile: undefined, categoryImage: '' };
    setCategories(updated);
  };

  const addCategory = () => {
    const nameToCheck = isArabicOnly ? categoryNameAr : categoryName;
    if (!nameToCheck.trim()) return;
    const newCategory = {
      categoryName: isArabicOnly ? (categoryNameAr || '').trim() : categoryName.trim(),
      categoryNameAr: isArabicOnly ? (categoryNameAr || '').trim() : (showArabic ? categoryNameAr.trim() : ''),
      categoryImage: '',
      items: [],
      subCategories: []
    };
    setCategories([...categories, newCategory]);
    setCategoryName('');
    setCategoryNameAr('');
  };

  const deleteCategory = (catIndex) => {
    const updated = categories.filter((_, i) => i !== catIndex);
    setCategories(updated);
    if (expandedCatIndex === catIndex) setExpandedCatIndex(null);
    else if (expandedCatIndex !== null && expandedCatIndex > catIndex) {
      setExpandedCatIndex(expandedCatIndex - 1);
    }
  };

  const moveCategory = (catIndex, delta) => {
    const next = catIndex + delta;
    if (next < 0 || next >= categories.length) return;
    const updated = [...categories];
    [updated[catIndex], updated[next]] = [updated[next], updated[catIndex]];
    setCategories(updated);
    if (expandedCatIndex === catIndex) setExpandedCatIndex(next);
    else if (expandedCatIndex === next) setExpandedCatIndex(catIndex);
  };

  const moveSubCategory = (catIndex, subIndex, delta) => {
    const subs = categories[catIndex]?.subCategories || [];
    const next = subIndex + delta;
    if (next < 0 || next >= subs.length) return;
    const updated = [...categories];
    const sc = [...(updated[catIndex].subCategories || [])];
    [sc[subIndex], sc[next]] = [sc[next], sc[subIndex]];
    updated[catIndex] = { ...updated[catIndex], subCategories: sc };
    setCategories(updated);
    if (expandedCatIndex === catIndex && expandedSubIndex === subIndex) setExpandedSubIndex(next);
    else if (expandedCatIndex === catIndex && expandedSubIndex === next) setExpandedSubIndex(subIndex);
  };

  const moveCategoryItem = (catIndex, itemIndex, delta) => {
    const items = categories[catIndex]?.items || [];
    const next = itemIndex + delta;
    if (next < 0 || next >= items.length) return;
    const updated = [...categories];
    const it = [...(updated[catIndex].items || [])];
    [it[itemIndex], it[next]] = [it[next], it[itemIndex]];
    updated[catIndex] = { ...updated[catIndex], items: it };
    setCategories(updated);
  };

  const moveSubCategoryItem = (catIndex, subIndex, itemIndex, delta) => {
    const items = categories[catIndex]?.subCategories?.[subIndex]?.items || [];
    const next = itemIndex + delta;
    if (next < 0 || next >= items.length) return;
    const updated = [...categories];
    const subs = [...(updated[catIndex].subCategories || [])];
    const it = [...(subs[subIndex].items || [])];
    [it[itemIndex], it[next]] = [it[next], it[itemIndex]];
    subs[subIndex] = { ...subs[subIndex], items: it };
    updated[catIndex] = { ...updated[catIndex], subCategories: subs };
    setCategories(updated);
  };

  const openEditCategory = (catIndex) => {
    setEditingCatIndex(catIndex);
    setEditCategoryName(categories[catIndex].categoryName);
    setEditCategoryNameAr(categories[catIndex].categoryNameAr || '');
    setEditCategoryDialog(true);
  };

  const saveEditCategory = () => {
    const nameToCheck = isArabicOnly ? editCategoryNameAr : editCategoryName;
    if (!nameToCheck.trim()) return;
    const updated = [...categories];
    updated[editingCatIndex].categoryName = isArabicOnly ? (editCategoryNameAr || '').trim() : editCategoryName.trim();
    updated[editingCatIndex].categoryNameAr = isArabicOnly ? (editCategoryNameAr || '').trim() : (showArabic ? editCategoryNameAr.trim() : '');
    setCategories(updated);
    setEditCategoryDialog(false);
    setEditingCatIndex(null);
    setEditCategoryName('');
    setEditCategoryNameAr('');
  };

  const toggleSubCategories = (index) => {
    setExpandedCatIndex((prev) => (prev === index ? null : index));
    setExpandedSubIndex(null);
  };

  const addSubCategory = (catIndex) => {
    const nameToCheck = isArabicOnly ? subCategoryNameAr : subCategoryName;
    if (!nameToCheck.trim()) return;
    const updated = [...categories];
    const newSubCategory = {
      name: isArabicOnly ? (subCategoryNameAr || '').trim() : subCategoryName.trim(),
      nameAr: isArabicOnly ? (subCategoryNameAr || '').trim() : (showArabic ? subCategoryNameAr.trim() : ''),
      items: []
    };
    updated[catIndex].subCategories.push(newSubCategory);
    setCategories(updated);
    setSubCategoryName('');
    setSubCategoryNameAr('');
  };

  const deleteSubCategory = (catIndex, subIndex) => {
    const updated = [...categories];
    updated[catIndex].subCategories = updated[catIndex].subCategories.filter((_, i) => i !== subIndex);
    setCategories(updated);
    if (expandedSubIndex === subIndex) setExpandedSubIndex(null);
  };

  const openEditSubCategory = (catIndex, subIndex) => {
    setEditingCatIndex(catIndex);
    setEditingSubIndex(subIndex);
    setEditSubCategoryName(categories[catIndex].subCategories[subIndex].name);
    setEditSubCategoryNameAr(categories[catIndex].subCategories[subIndex].nameAr || '');
    setEditSubDialog(true);
  };

  const saveEditSubCategory = () => {
    const nameToCheck = isArabicOnly ? editSubCategoryNameAr : editSubCategoryName;
    if (!nameToCheck.trim()) return;
    const updated = [...categories];
    updated[editingCatIndex].subCategories[editingSubIndex].name = isArabicOnly ? (editSubCategoryNameAr || '').trim() : editSubCategoryName.trim();
    updated[editingCatIndex].subCategories[editingSubIndex].nameAr = isArabicOnly ? (editSubCategoryNameAr || '').trim() : (showArabic ? editSubCategoryNameAr.trim() : '');
    setCategories(updated);
    setEditSubDialog(false);
    setEditingCatIndex(null);
    setEditingSubIndex(null);
    setEditSubCategoryName('');
    setEditSubCategoryNameAr('');
  };

  const toggleItems = (subIndex) => {
    setExpandedSubIndex((prev) => (prev === subIndex ? null : subIndex));
  };

  const addItem = (catIndex, subIndex) => {
    const titleToCheck = isArabicOnly ? itemTitleAr : itemTitle;
    if (!titleToCheck.trim()) return;
    const updated = [...categories];
    const newItem = {
      name: isArabicOnly ? (itemTitleAr || '').trim() : itemTitle.trim(),
      nameAr: isArabicOnly ? (itemTitleAr || '').trim() : (showArabic ? itemTitleAr.trim() : ''),
      title: isArabicOnly ? (itemTitleAr || '').trim() : itemTitle.trim(),
      titleAr: isArabicOnly ? (itemTitleAr || '').trim() : (showArabic ? itemTitleAr.trim() : ''),
      desc: isArabicOnly ? (itemDescAr || '').trim() : itemDesc.trim(),
      descAr: isArabicOnly ? (itemDescAr || '').trim() : (showArabic ? itemDescAr.trim() : ''),
      price: itemPrice,
      image: '',
    };
    updated[catIndex].subCategories[subIndex].items.push(newItem);
    setCategories(updated);
    setItemTitle('');
    setItemTitleAr('');
    setItemDesc('');
    setItemDescAr('');
    setItemPrice('');
  };

  const addItemToCategory = (catIndex) => {
    const titleToCheck = isArabicOnly ? itemTitleAr : itemTitle;
    if (!titleToCheck.trim()) return;
    const updated = [...categories];
    if (!updated[catIndex].items) updated[catIndex].items = [];
    const newItem = {
      name: isArabicOnly ? (itemTitleAr || '').trim() : itemTitle.trim(),
      nameAr: isArabicOnly ? (itemTitleAr || '').trim() : (showArabic ? itemTitleAr.trim() : ''),
      title: isArabicOnly ? (itemTitleAr || '').trim() : itemTitle.trim(),
      titleAr: isArabicOnly ? (itemTitleAr || '').trim() : (showArabic ? itemTitleAr.trim() : ''),
      desc: isArabicOnly ? (itemDescAr || '').trim() : itemDesc.trim(),
      descAr: isArabicOnly ? (itemDescAr || '').trim() : (showArabic ? itemDescAr.trim() : ''),
      price: itemPrice,
      image: '',
    };
    updated[catIndex].items.push(newItem);
    setCategories(updated);
    setItemTitle('');
    setItemTitleAr('');
    setItemDesc('');
    setItemDescAr('');
    setItemPrice('');
  };

  const deleteItem = (catIndex, subIndex, itemIndex) => {
    const updated = [...categories];
    updated[catIndex].subCategories[subIndex].items = updated[catIndex].subCategories[subIndex].items.filter((_, i) => i !== itemIndex);
    setCategories(updated);
  };

  const deleteCategoryItem = (catIndex, itemIndex) => {
    const updated = [...categories];
    if (!updated[catIndex].items) return;
    updated[catIndex].items = updated[catIndex].items.filter((_, i) => i !== itemIndex);
    setCategories(updated);
  };

  const openEditItem = (catIndex, subIndex, itemIndex) => {
    setEditingCatIndex(catIndex);
    setEditingSubIndex(subIndex);
    setEditingItemIndex(itemIndex);
    const item = subIndex === -1
      ? (categories[catIndex].items || [])[itemIndex]
      : categories[catIndex].subCategories[subIndex].items[itemIndex];
    if (!item) return;
    setEditItemTitle(item.title || item.name || '');
    setEditItemTitleAr(item.titleAr || item.nameAr || '');
    setEditItemDesc(item.desc || '');
    setEditItemDescAr(item.descAr || '');
    setEditItemPrice(item.price || '');
    setEditItemDialog(true);
  };

  const saveEditItem = () => {
    const titleToCheck = isArabicOnly ? editItemTitleAr : editItemTitle;
    if (!titleToCheck.trim()) return;
    const updated = [...categories];
    const itemData = {
      name: isArabicOnly ? (editItemTitleAr || '').trim() : editItemTitle.trim(),
      nameAr: isArabicOnly ? (editItemTitleAr || '').trim() : (showArabic ? editItemTitleAr.trim() : ''),
      title: isArabicOnly ? (editItemTitleAr || '').trim() : editItemTitle.trim(),
      titleAr: isArabicOnly ? (editItemTitleAr || '').trim() : (showArabic ? editItemTitleAr.trim() : ''),
      desc: isArabicOnly ? (editItemDescAr || '').trim() : editItemDesc.trim(),
      descAr: isArabicOnly ? (editItemDescAr || '').trim() : (showArabic ? editItemDescAr.trim() : ''),
      price: editItemPrice,
      image: '',
    };
    if (editingSubIndex === -1) {
      if (!updated[editingCatIndex].items) updated[editingCatIndex].items = [];
      updated[editingCatIndex].items[editingItemIndex] = itemData;
    } else {
      updated[editingCatIndex].subCategories[editingSubIndex].items[editingItemIndex] = itemData;
    }
    setCategories(updated);
    setEditItemDialog(false);
    setEditingCatIndex(null);
    setEditingSubIndex(null);
    setEditingItemIndex(null);
    setEditItemTitle('');
    setEditItemTitleAr('');
    setEditItemDesc('');
    setEditItemDescAr('');
    setEditItemPrice('');
  };

  const saveRestaurant = async () => {
    const nameToCheck = isArabicOnly ? resturentNameAr : resturentName;
    if (!nameToCheck.trim()) {
      setSaveError(isArabicOnly ? 'اسم المطعم مطلوب' : 'Restaurant name is required');
      setSaveMessage('');
      return;
    }

    const whatsappValidation = validateWhatsAppNumber(whatsappNumber, {
      required: userType == 1 && subscriptionPlan === 'Pro',
    });
    if (!whatsappValidation.valid) {
      setSaveError(whatsappValidation.message);
      setSaveMessage('');
      return;
    }

    if (userType == 1 && taxPercentage !== '' && (Number(taxPercentage) < 0 || Number(taxPercentage) > 100)) {
      setSaveError('Tax percentage must be between 0 and 100');
      setSaveMessage('');
      return;
    }

    if (userType == 1 && servicePercentage !== '' && (Number(servicePercentage) < 0 || Number(servicePercentage) > 100)) {
      setSaveError('Service percentage must be between 0 and 100');
      setSaveMessage('');
      return;
    }

    if (loading) {
      return;
    }

    setIsSaving(true);
    setSaveError('');
    setSaveMessage('');

    const token = localStorage.getItem('auth-token');
    
    try {
      const formData = new FormData();
      formData.append('resturentName', isArabicOnly ? (resturentNameAr || '').trim() : resturentName.trim());
      formData.append('resturentNameAr', isArabicOnly ? (resturentNameAr || '').trim() : (resturentNameAr || '').trim());
      const categoriesForSubmit = categories.map(cat => {
        const { imageFile, ...rest } = cat;
        return { ...rest, categoryImage: imageFile ? '' : (rest.categoryImage || '') };
      });
      formData.append('categories', JSON.stringify(categoriesForSubmit));
      const categoryImageIndices = [];
      categories.forEach((cat, idx) => {
        if (cat.imageFile) {
          formData.append('categoryImages', cat.imageFile);
          categoryImageIndices.push(idx);
        }
      });
      if (categoryImageIndices.length > 0) {
        formData.append('categoryImageIndices', JSON.stringify(categoryImageIndices));
      }
      formData.append('menuLanguage', menuLanguage);
      formData.append('isBilingual', isBilingual);
      formData.append('location', location.trim());
      formData.append('locationLink', locationLink.trim());
      formData.append('locationLabel', isArabicOnly ? (locationLabelAr || '').trim() : locationLabel.trim());
      formData.append('locationLabelAr', isArabicOnly ? (locationLabelAr || '').trim() : (locationLabelAr || '').trim());
      formData.append('phoneNumber', phoneNumber.trim());
      formData.append('currency', currency.trim());
      if (userType == 1) {
        formData.append('taxPercentage', taxPercentage.trim() || '0');
        formData.append('servicePercentage', servicePercentage.trim() || '0');
      }
      formData.append('expireDate', expireDate || '');
      formData.append('facebookLink', facebookLink.trim());
      formData.append('instagramLink', instagramLink.trim());
      formData.append('googleReviewLink', googleReviewLink.trim());
      formData.append('whatsappLink', whatsappLink.trim());
      if (userType == 1) {
        formData.append('whatsappNumber', whatsappNumber.trim());
        formData.append('subscriptionPlan', subscriptionPlan);
      }
      formData.append('primaryColor', primaryColor.trim() || '#ec4913');
      formData.append('backgroundColor', backgroundColor.trim() || '#1a1410');
      formData.append('userId', selectedUserId || '');
      if (resturentImageFile) {
        formData.append('resturentImage', resturentImageFile);
      }

      await axios.put(
        `/updateResturent/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      setSaveMessage('Restaurant updated successfully!');
      setSaveError('');
      setTimeout(() => {
        navigate('/AllResturent');
      }, 1500);
    } catch (err) {
      setSaveError(err.response?.data?.message || 'Failed to update restaurant');
      setSaveMessage('');
    } finally {
      setIsSaving(false);
    }
  };

  if (loading) {
    return (
      <>
        <AdminNav />
        <Container maxWidth="lg" sx={{ py: 4, textAlign: 'center' }}>
          <CircularProgress />
          <Typography sx={{ mt: 2 }}>Loading restaurant...</Typography>
        </Container>
      </>
    );
  }

  return (
    <>
      <AdminNav />
      <Container 
       className='add-resturent-container'
        maxWidth="lg" 
        sx={{ 
          py: { xs: 2, sm: 3, md: 4 },
          px: { xs: 2, sm: 3 }
        }}
      >
        <Box 
          sx={{ 
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: { xs: 2, sm: 3 },
            flexDirection: { xs: 'column', sm: 'row' },
            gap: 2
          }}
        >
          <Typography 
            variant="h4" 
            sx={{ 
              fontSize: { xs: '1.5rem', sm: '2rem', md: '2.125rem' },
              fontWeight: 600,
              color: 'primary.main'
            }}
          >
            Edit Restaurant Menu
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              variant="outlined"
              onClick={() => navigate('/AllResturent')}
              sx={{
                px: 3,
                py: 1.5,
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="success"
              size="large"
              startIcon={<SaveIcon />}
              onClick={saveRestaurant}
              disabled={isSaving || !(isArabicOnly ? resturentNameAr : resturentName).trim()}
              sx={{
                px: 4,
                py: 1.5,
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600,
                fontSize: '1rem',
                boxShadow: 3,
                '&:hover': {
                  boxShadow: 6
                }
              }}
            >
              {isSaving ? 'Saving...' : 'Update Restaurant'}
            </Button>
          </Box>
        </Box>

        {saveMessage && (
          <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSaveMessage('')}>
            {saveMessage}
          </Alert>
        )}
        {saveError && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setSaveError('')}>
            {saveError}
          </Alert>
        )}

        {/* Restaurant Information */}
        <Card 
          sx={{ 
            mb: { xs: 2, sm: 3 },
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            borderRadius: 2
          }}
        >
          <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
            <Typography 
              variant="h6" 
              gutterBottom
              sx={{ 
                fontSize: { xs: '1rem', sm: '1.125rem' },
                fontWeight: 600,
                mb: 2
              }}
            >
              Restaurant Information
            </Typography>
            {userType == 1 && (
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel id="edit-restaurant-select-user-label">Select user</InputLabel>
              <Select
                labelId="edit-restaurant-select-user-label"
                id="edit-restaurant-select-user"
                value={selectedUserId}
                label="Select user"
                onChange={(e) => setSelectedUserId(e.target.value)}
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}
              >
                
                {usersType4.map((user) => (
                  <MenuItem key={user._id} value={user._id}>
                    {user.userName || user.email || user._id}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            )}
            <Box sx={{ display: 'grid', gridTemplateColumns: isArabicOnly ? '1fr' : showArabic ? '1fr 1fr' : '1fr', gap: 2, mb: 3 }}>
              {!isArabicOnly && (
                <TextField
                  label="Restaurant Name (English)"
                  variant="outlined"
                  fullWidth
                  value={resturentName}
                  onChange={(e) => setResturentName(e.target.value)}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}
                />
              )}
              {(showArabic || isArabicOnly) && (
                <TextField
                  label={isArabicOnly ? 'اسم المطعم' : 'اسم المطعم (عربي)'}
                  variant="outlined"
                  fullWidth
                  value={resturentNameAr}
                  onChange={(e) => setResturentNameAr(e.target.value)}
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5 }, direction: 'rtl' }}
                  inputProps={{ dir: 'rtl' }}
                />
              )}
            </Box>

            {/* Restaurant Image */}
            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" sx={{ mb: 1, fontWeight: 600 }}>
                Restaurant Image
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Button
                  variant="outlined"
                  component="label"
                  sx={{ textTransform: 'none', borderRadius: 1.5, py: 1.5 }}
                >
                  {imagePreview ? 'Change Image' : 'Upload Image'}
                  <input type="file" hidden accept="image/*" onChange={handleImageChange} />
                </Button>
                {imagePreview && (
                  <Box sx={{ position: 'relative', width: 'fit-content' }}>
                    <img
                      src={imagePreview}
                      alt="Restaurant"
                      style={{
                        maxWidth: '300px',
                        maxHeight: '200px',
                        borderRadius: '8px',
                        objectFit: 'cover'
                      }}
                    />
                    <IconButton
                      onClick={removeImage}
                      sx={{
                        position: 'absolute',
                        top: -10,
                        right: -10,
                        bgcolor: 'error.main',
                        color: 'white',
                        '&:hover': { bgcolor: 'error.dark' }
                      }}
                      size="small"
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Box>
                )}
              </Box>
            </Box>

            {/* Menu Colors */}
            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" sx={{ mb: 1.5, fontWeight: 600 }}>
                Menu Colors
              </Typography>
              <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
                <Box>
                  <Typography variant="caption" sx={{ display: 'block', mb: 0.5, color: 'text.secondary' }}>Orange / Accent Color</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <input
                      type="color"
                      value={primaryColor}
                      onChange={(e) => setPrimaryColor(e.target.value)}
                      style={{ width: 48, height: 40, border: '1px solid #ccc', borderRadius: 8, cursor: 'pointer', padding: 2 }}
                    />
                    <TextField
                      size="small"
                      value={primaryColor}
                      onChange={(e) => setPrimaryColor(e.target.value)}
                      placeholder="#ec4913"
                      sx={{ flex: 1, '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}
                    />
                  </Box>
                </Box>
                <Box>
                  <Typography variant="caption" sx={{ display: 'block', mb: 0.5, color: 'text.secondary' }}>Background Color</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <input
                      type="color"
                      value={backgroundColor}
                      onChange={(e) => setBackgroundColor(e.target.value)}
                      style={{ width: 48, height: 40, border: '1px solid #ccc', borderRadius: 8, cursor: 'pointer', padding: 2 }}
                    />
                    <TextField
                      size="small"
                      value={backgroundColor}
                      onChange={(e) => setBackgroundColor(e.target.value)}
                      placeholder="#1a1410"
                      sx={{ flex: 1, '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>

            {/* Expire Date */}
            {userType == 1 && (
            <Box sx={{ mb: 2 }}>
              <TextField
                label="Expire Date"
                type="date"
                variant="outlined"
                fullWidth
                value={expireDate}
                onChange={(e) => setExpireDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{ maxWidth: 280, '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}
              />
            </Box>
            )}
            {/* Location & Social Links */}
            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" sx={{ mb: 1.5, fontWeight: 600 }}>
                Location & Social Media
              </Typography>
              <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
                <TextField
                  label="Location Link (URL)"
                  variant="outlined"
                  fullWidth
                  value={locationLink}
                  onChange={(e) => setLocationLink(e.target.value)}
                  placeholder="e.g. https://maps.google.com/... or Google Maps link"
                  sx={{ gridColumn: { xs: '1', sm: 'span 2' }, '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}
                />
                {!isArabicOnly && (
                  <TextField
                    label="Location Label (English)"
                    variant="outlined"
                    fullWidth
                    value={locationLabel}
                    onChange={(e) => setLocationLabel(e.target.value)}
                    placeholder="e.g. Main Branch, Downtown"
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}
                  />
                )}
                {(showArabic || isArabicOnly) && (
                  <TextField
                    label={isArabicOnly ? 'عنوان الموقع' : 'عنوان الموقع (عربي)'}
                    variant="outlined"
                    fullWidth
                    value={locationLabelAr}
                    onChange={(e) => setLocationLabelAr(e.target.value)}
                    placeholder="مثال: الفرع الرئيسي"
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5 }, direction: 'rtl' }}
                    inputProps={{ dir: 'rtl' }}
                  />
                )}
                <TextField
                  label="Phone (for call)"
                  variant="outlined"
                  fullWidth
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  placeholder="e.g. +1234567890"
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}
                />
                <TextField
                  label="Currency"
                  variant="outlined"
                  fullWidth
                  value={currency}
                  onChange={(e) => setCurrency(e.target.value)}
                  placeholder="e.g. JOD, USD, $, د.أ"
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}
                />
                {userType == 1 && (
                  <>
                    <TextField
                      label="Tax Percentage (%)"
                      variant="outlined"
                      fullWidth
                      type="number"
                      inputProps={{ min: 0, max: 100, step: 0.01 }}
                      value={taxPercentage}
                      onChange={(e) => setTaxPercentage(e.target.value)}
                      placeholder="e.g. 16"
                      helperText="Applied at checkout on the public menu (0 = no tax)"
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}
                    />
                    <TextField
                      label="Service Percentage (%)"
                      variant="outlined"
                      fullWidth
                      type="number"
                      inputProps={{ min: 0, max: 100, step: 0.01 }}
                      value={servicePercentage}
                      onChange={(e) => setServicePercentage(e.target.value)}
                      placeholder="e.g. 10"
                      helperText="Service charge applied at checkout (0 = no service fee)"
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}
                    />
                  </>
                )}
                <TextField
                  label="Facebook URL"
                  variant="outlined"
                  fullWidth
                  value={facebookLink}
                  onChange={(e) => setFacebookLink(e.target.value)}
                  placeholder="https://facebook.com/..."
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}
                />
                <TextField
                  label="Instagram URL"
                  variant="outlined"
                  fullWidth
                  value={instagramLink}
                  onChange={(e) => setInstagramLink(e.target.value)}
                  placeholder="https://instagram.com/..."
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}
                />
                <TextField
                  label="Google Review URL"
                  variant="outlined"
                  fullWidth
                  value={googleReviewLink}
                  onChange={(e) => setGoogleReviewLink(e.target.value)}
                  placeholder="https://g.page/r/.../review"
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}
                />
                <TextField
                  label="WhatsApp Contact (optional)"
                  variant="outlined"
                  fullWidth
                  value={whatsappLink}
                  onChange={(e) => setWhatsappLink(e.target.value)}
                  placeholder="+1234567890 or wa.me link"
                  helperText="Shown as contact icon on menu header"
                  sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}
                />
                {userType == 1 && (
                  <>
                    <FormControl fullWidth sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}>
                      <InputLabel>Subscription Plan</InputLabel>
                      <Select
                        value={subscriptionPlan}
                        label="Subscription Plan"
                        onChange={(e) => setSubscriptionPlan(e.target.value)}
                      >
                        <MenuItem value="Starter">Starter — Digital Menu only</MenuItem>
                        <MenuItem value="Pro">Pro — Digital Menu + WhatsApp Ordering</MenuItem>
                      </Select>
                    </FormControl>
                    {subscriptionPlan === 'Pro' && (
                      <TextField
                        required
                        label="WhatsApp Order Number"
                        variant="outlined"
                        fullWidth
                        value={whatsappNumber}
                        onChange={(e) => setWhatsappNumber(e.target.value)}
                        placeholder="e.g. +962790000000"
                        helperText="Orders will be sent to this WhatsApp number"
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}
                      />
                    )}
                  </>
                )}
              </Box>
            </Box>

            {/* Menu language */}
            <Box>
              <Typography variant="body2" sx={{ mb: 1.5, fontWeight: 600 }}>
                Menu language
              </Typography>
              <FormControl component="fieldset" sx={{ width: '100%' }}>
                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 1.5, flexWrap: 'wrap' }}>
                  {[
                    { value: 'en', label: 'English only' },
                    { value: 'ar', label: 'Arabic only (العربية فقط)' },
                    { value: 'both', label: 'Both (Arabic & English)' }
                  ].map((opt) => (
                    <FormControlLabel
                      key={opt.value}
                      control={
                        <Checkbox
                          checked={menuLanguage === opt.value}
                          onChange={() => setMenuLanguage(opt.value)}
                          sx={{ color: '#86C85D', '&.Mui-checked': { color: '#86C85D' } }}
                        />
                      }
                      label={opt.label}
                      sx={{
                        flex: '1 1 auto',
                        minWidth: { xs: '100%', sm: 140 },
                        bgcolor: menuLanguage === opt.value ? 'rgba(134, 200, 93, 0.08)' : 'grey.50',
                        border: '1px solid',
                        borderColor: menuLanguage === opt.value ? '#86C85D' : 'grey.300',
                        borderRadius: 1.5,
                        p: 1.5,
                        m: 0,
                        transition: 'all 0.2s ease',
                        '&:hover': { bgcolor: menuLanguage === opt.value ? 'rgba(134, 200, 93, 0.12)' : 'grey.100' }
                      }}
                    />
                  ))}
                </Box>
              </FormControl>
              {menuLanguage === 'both' && (
                <Alert severity="info" sx={{ mt: 2, borderRadius: 1.5, '& .MuiAlert-icon': { color: '#86C85D' } }}>
                  Customers will be able to switch between Arabic and English on the menu.
                </Alert>
              )}
              {menuLanguage === 'ar' && (
                <Alert severity="info" sx={{ mt: 2, borderRadius: 1.5, '& .MuiAlert-icon': { color: '#86C85D' } }}>
                  Menu will be displayed in Arabic with RTL direction.
                </Alert>
              )}
            </Box>
          </CardContent>
        </Card>

        {/* Categories section - same as addResturent */}
        <Card 
          sx={{ 
            mb: { xs: 2, sm: 3 },
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            borderRadius: 2
          }}
        >
          <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
            <Typography 
              variant="h6" 
              gutterBottom
              sx={{ 
                fontSize: { xs: '1rem', sm: '1.125rem' },
                fontWeight: 600,
                mb: 2
              }}
            >
              Menu Categories
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
              Use the arrows on each row to change display order on the public menu. Save the restaurant to apply.
            </Typography>
            <Box sx={{ mb: 3 }}>
              <Box 
                sx={{ 
                  display: 'grid',
                  gridTemplateColumns: isArabicOnly ? '1fr' : (showArabic ? { xs: '1fr', sm: '1fr 1fr' } : '1fr'),
                  gap: 2,
                  mb: 2
                }}
              >
                {!isArabicOnly && (
                  <TextField
                    label="Category Name (English)"
                    variant="outlined"
                    value={categoryName}
                    onChange={(e) => setCategoryName(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && addCategory()}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}
                  />
                )}
                {(showArabic || isArabicOnly) && (
                  <TextField
                    label={isArabicOnly ? 'اسم الفئة' : 'اسم الفئة (عربي)'}
                    variant="outlined"
                    value={categoryNameAr}
                    onChange={(e) => setCategoryNameAr(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && addCategory()}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5 }, direction: 'rtl' }}
                    inputProps={{ dir: 'rtl' }}
                  />
                )}
              </Box>
              <Button 
                variant="contained" 
                startIcon={<AddIcon />} 
                onClick={addCategory}
                fullWidth
                sx={{
                  py: 1.5,
                  borderRadius: 1.5,
                  textTransform: 'none',
                  fontSize: '0.875rem',
                  fontWeight: 600,
                  boxShadow: 2,
                  '&:hover': { boxShadow: 4 }
                }}
              >
                Add Category
              </Button>
            </Box>

            {/* Categories list with subcategories and items */}
            {categories.length > 0 && (
              <List sx={{ p: 0 }}>
                {categories.map((cat, catIndex) => {
                  const isExpanded = expandedCatIndex === catIndex;
                  const subCategories = cat.subCategories || [];
                  return (
                    <Card 
                      key={catIndex} 
                      sx={{ 
                        mb: 2,
                        border: '2px solid',
                        borderColor: isExpanded ? 'primary.main' : 'divider',
                        borderRadius: 2,
                        boxShadow: isExpanded ? '0 4px 12px rgba(0,0,0,0.15)' : '0 1px 4px rgba(0,0,0,0.08)',
                        transition: 'all 0.2s ease'
                      }}
                    >
                      <CardContent sx={{ p: { xs: 2, sm: 2.5 } }}>
                        <Box 
                          sx={{ 
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },
                            alignItems: { xs: 'flex-start', sm: 'center' },
                            justifyContent: 'space-between',
                            gap: { xs: 1.5, sm: 1 },
                            mb: isExpanded ? 2 : 0
                          }}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, flexWrap: 'wrap' }}>
                            <Box>
                              <Typography variant="subtitle1" sx={{ fontWeight: 700, fontSize: { xs: '1rem', sm: '1.125rem' }, color: 'text.primary' }}>
                                {cat.categoryName}
                              </Typography>
                              {showArabic && cat.categoryNameAr && (
                                <Typography variant="body2" sx={{ color: 'text.secondary', fontStyle: 'italic', direction: 'rtl' }}>
                                  {cat.categoryNameAr}
                                </Typography>
                              )}
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <Button variant="outlined" component="label" size="small" sx={{ textTransform: 'none' }}>
                                {(cat.categoryImage || cat.imageFile) ? 'Change' : 'Upload'} image
                                <input type="file" hidden accept="image/*" onChange={(e) => handleCategoryImageChange(catIndex, e)} />
                              </Button>
                              {(cat.categoryImage || cat.imageFile) && (
                                <Box sx={{ position: 'relative' }}>
                                  <img src={cat.categoryImage} alt="" style={{ width: 56, height: 56, objectFit: 'cover', borderRadius: 8 }} />
                                  <IconButton size="small" onClick={() => removeCategoryImage(catIndex)} sx={{ position: 'absolute', top: -8, right: -8, bgcolor: 'error.main', color: 'white', width: 22, height: 22, '&:hover': { bgcolor: 'error.dark' } }}>
                                    <DeleteIcon sx={{ fontSize: 14 }} />
                                  </IconButton>
                                </Box>
                              )}
                            </Box>
                          </Box>
                          <Box sx={{ display: 'flex', gap: 1, width: { xs: '100%', sm: 'auto' }, flexWrap: 'wrap', alignItems: 'center' }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
                              <IconButton
                                size="small"
                                aria-label="Move category up"
                                disabled={catIndex === 0}
                                onClick={() => moveCategory(catIndex, -1)}
                                sx={{ p: 0.25 }}
                              >
                                <ArrowUpwardIcon sx={{ fontSize: 18 }} />
                              </IconButton>
                              <IconButton
                                size="small"
                                aria-label="Move category down"
                                disabled={catIndex >= categories.length - 1}
                                onClick={() => moveCategory(catIndex, 1)}
                                sx={{ p: 0.25 }}
                              >
                                <ArrowDownwardIcon sx={{ fontSize: 18 }} />
                              </IconButton>
                            </Box>
                            <Button
                              size="small"
                              variant={isExpanded ? 'contained' : 'outlined'}
                              startIcon={isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                              onClick={() => toggleSubCategories(catIndex)}
                              sx={{
                                flexGrow: { xs: 1, sm: 0 },
                                textTransform: 'none',
                                borderRadius: 1.5,
                                fontSize: '0.813rem',
                                fontWeight: 600,
                                px: 2
                              }}
                            >
                              {isExpanded ? 'Hide' : 'Show'} Subs
                            </Button>
                            <IconButton 
                              size="small" 
                              color="primary" 
                              onClick={() => openEditCategory(catIndex)}
                              sx={{
                                bgcolor: 'primary.lighter',
                                '&:hover': {
                                  bgcolor: 'primary.light'
                                }
                              }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                            <IconButton 
                              size="small" 
                              color="error" 
                              onClick={() => deleteCategory(catIndex)}
                              sx={{
                                bgcolor: 'error.lighter',
                                '&:hover': {
                                  bgcolor: 'error.light'
                                }
                              }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Box>
                        </Box>

                        {/* Subcategories section (same as addResturent) */}
                        {isExpanded && (
                          <Box 
                            sx={{ 
                              pl: { xs: 0, sm: 2 },
                              pt: 2,
                              borderTop: '2px solid',
                              borderColor: 'primary.light',
                              bgcolor: 'grey.50',
                              p: { xs: 2, sm: 2.5 },
                              borderRadius: 1.5,
                              mt: 1
                            }}
                          >
                            {/* Items in this category (direct) */}
                            <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600, fontSize: '0.875rem', color: 'text.secondary', mb: 1.5 }}>
                              Items in this category (direct)
                            </Typography>
                            <Box sx={{ pt: 1.5, pb: 2, borderBottom: '1px dashed', borderColor: 'grey.300', mb: 2 }}>
                              <Typography variant="caption" display="block" gutterBottom sx={{ fontWeight: 600, fontSize: '0.813rem', color: 'text.secondary', mb: 1.5 }}>Add Item Details</Typography>
                              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr', gap: 1.5, mb: 2 }}>
                                <Box sx={{ display: 'grid', gridTemplateColumns: isArabicOnly ? '1fr' : showArabic ? '1fr 1fr' : '1fr', gap: 1.5 }}>
                                  {!isArabicOnly && <TextField label="Title (English)" size="small" value={itemTitle} onChange={(e) => setItemTitle(e.target.value)} sx={{ bgcolor: 'white', '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }} />}
                                  {(showArabic || isArabicOnly) && <TextField label={isArabicOnly ? 'العنوان' : 'العنوان (عربي)'} size="small" value={itemTitleAr} onChange={(e) => setItemTitleAr(e.target.value)} sx={{ bgcolor: 'white', '& .MuiOutlinedInput-root': { borderRadius: 1.5 }, direction: 'rtl' }} inputProps={{ dir: 'rtl' }} />}
                                </Box>
                                <Box sx={{ display: 'grid', gridTemplateColumns: isArabicOnly ? '1fr' : showArabic ? '1fr 1fr' : '1fr', gap: 1.5 }}>
                                  {!isArabicOnly && <TextField label="Description (English)" size="small" multiline rows={2} value={itemDesc} onChange={(e) => setItemDesc(e.target.value)} sx={{ bgcolor: 'white', '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }} />}
                                  {(showArabic || isArabicOnly) && <TextField label={isArabicOnly ? 'الوصف' : 'الوصف (عربي)'} size="small" multiline rows={2} value={itemDescAr} onChange={(e) => setItemDescAr(e.target.value)} sx={{ bgcolor: 'white', '& .MuiOutlinedInput-root': { borderRadius: 1.5 }, direction: 'rtl' }} inputProps={{ dir: 'rtl' }} />}
                                </Box>
                                <TextField label="Price" size="small" type="number" value={itemPrice} onChange={(e) => setItemPrice(e.target.value)} sx={{ bgcolor: 'white', '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }} />
                              </Box>
                              <Button size="small" variant="contained" color="primary" startIcon={<AddIcon />} onClick={() => addItemToCategory(catIndex)} fullWidth sx={{ textTransform: 'none', borderRadius: 1.5, py: 1, fontWeight: 600, fontSize: '0.875rem' }}>
                                Add Item to category
                              </Button>
                              {(cat.items || []).length > 0 && (
                                <Box sx={{ mt: 2 }}>
                                  <Typography variant="caption" sx={{ fontWeight: 600, fontSize: '0.813rem', color: 'text.secondary', display: 'block', mb: 1 }}>Category items</Typography>
                                  <List dense disablePadding>
                                    {(cat.items || []).map((item, itemIndex) => (
                                      <ListItem key={itemIndex} sx={{ border: '1px solid', borderColor: 'grey.300', borderRadius: 1.5, mb: 1, bgcolor: 'white', p: 1.5, display: 'flex', alignItems: 'flex-start', flexDirection: { xs: 'column', sm: 'row' }, gap: 1 }}>
                                        <Box sx={{ flexGrow: 1 }}>
                                          <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '0.875rem', mb: 0.5 }}>{item.name || item.title}</Typography>
                                          {showArabic && (item.nameAr || item.titleAr) && <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '0.875rem', mb: 0.5, color: 'text.secondary', direction: 'rtl' }}>{item.nameAr || item.titleAr}</Typography>}
                                          <Typography variant="caption" sx={{ fontSize: '0.75rem', color: 'text.secondary', display: 'block' }}>{item.desc || 'No description'}</Typography>
                                          <Typography variant="caption" sx={{ fontSize: '0.75rem', color: 'primary.main', fontWeight: 600, display: 'block', mt: 0.5 }}>${item.price || '0'}</Typography>
                                        </Box>
                                        <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center', flexShrink: 0 }}>
                                          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                                            <IconButton size="small" aria-label="Move item up" disabled={itemIndex === 0} onClick={() => moveCategoryItem(catIndex, itemIndex, -1)} sx={{ p: 0.25 }}>
                                              <ArrowUpwardIcon sx={{ fontSize: 16 }} />
                                            </IconButton>
                                            <IconButton size="small" aria-label="Move item down" disabled={itemIndex >= (cat.items || []).length - 1} onClick={() => moveCategoryItem(catIndex, itemIndex, 1)} sx={{ p: 0.25 }}>
                                              <ArrowDownwardIcon sx={{ fontSize: 16 }} />
                                            </IconButton>
                                          </Box>
                                          <IconButton size="small" onClick={() => openEditItem(catIndex, -1, itemIndex)} sx={{ bgcolor: 'grey.200', '&:hover': { bgcolor: 'grey.300' } }}><EditIcon fontSize="small" /></IconButton>
                                          <IconButton size="small" color="error" onClick={() => deleteCategoryItem(catIndex, itemIndex)} sx={{ bgcolor: 'error.lighter', '&:hover': { bgcolor: 'error.light' } }}><DeleteIcon fontSize="small" /></IconButton>
                                        </Box>
                                      </ListItem>
                                    ))}
                                  </List>
                                </Box>
                              )}
                            </Box>

                            <Typography 
                              variant="subtitle2" 
                              gutterBottom
                              sx={{ 
                                fontWeight: 600,
                                fontSize: '0.875rem',
                                color: 'text.secondary',
                                mb: 1.5
                              }}
                            >
                              Add Subcategory
                            </Typography>
                            <Box sx={{ mb: 2 }}>
                              <Box 
                                sx={{ 
                                  display: 'grid',
                                  gridTemplateColumns: isArabicOnly ? '1fr' : (showArabic ? { xs: '1fr', sm: '1fr 1fr' } : '1fr'),
                                  gap: 1,
                                  mb: 1
                                }}
                              >
                                {!isArabicOnly && (
                                  <TextField
                                    label="Subcategory Name (English)"
                                    size="small"
                                    value={subCategoryName}
                                    onChange={(e) => setSubCategoryName(e.target.value)}
                                    onKeyDown={(e) => e.key === 'Enter' && addSubCategory(catIndex)}
                                    sx={{ bgcolor: 'white', '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }}
                                  />
                                )}
                                {(showArabic || isArabicOnly) && (
                                  <TextField
                                    label={isArabicOnly ? 'اسم الفئة الفرعية' : 'اسم الفئة الفرعية (عربي)'}
                                    size="small"
                                    value={subCategoryNameAr}
                                    onChange={(e) => setSubCategoryNameAr(e.target.value)}
                                    onKeyDown={(e) => e.key === 'Enter' && addSubCategory(catIndex)}
                                    sx={{ bgcolor: 'white', '& .MuiOutlinedInput-root': { borderRadius: 1.5 }, direction: 'rtl' }}
                                    inputProps={{ dir: 'rtl' }}
                                  />
                                )}
                              </Box>
                              <Button 
                                size="small" 
                                variant="contained" 
                                startIcon={<AddIcon />} 
                                onClick={() => addSubCategory(catIndex)}
                                fullWidth
                                sx={{ textTransform: 'none', borderRadius: 1.5, px: 2.5, fontWeight: 600 }}
                              >
                                Add
                              </Button>
                            </Box>

                            {/* Subcategories list */}
                            {subCategories.length > 0 && (
                              <List dense sx={{ p: 0 }}>
                                {subCategories.map((sub, subIndex) => {
                                  const isSubExpanded = expandedSubIndex === subIndex;
                                  const items = sub.items || [];
                                  return (
                                    <Card 
                                      key={subIndex} 
                                      variant="outlined" 
                                      sx={{ 
                                        mb: 1.5,
                                        bgcolor: 'white',
                                        border: isSubExpanded ? '2px solid' : '1px solid',
                                        borderColor: isSubExpanded ? 'secondary.main' : 'grey.300',
                                        borderRadius: 1.5,
                                        boxShadow: isSubExpanded ? '0 2px 8px rgba(0,0,0,0.1)' : 'none',
                                        transition: 'all 0.2s ease'
                                      }}
                                    >
                                      <CardContent sx={{ p: { xs: 1.5, sm: 2 } }}>
                                        <Box 
                                          sx={{ 
                                            display: 'flex',
                                            flexDirection: { xs: 'column', sm: 'row' },
                                            alignItems: { xs: 'flex-start', sm: 'center' },
                                            justifyContent: 'space-between',
                                            gap: 1,
                                            mb: isSubExpanded ? 1.5 : 0
                                          }}
                                        >
                                          <Box>
                                            <Typography 
                                              variant="body2" 
                                              sx={{
                                                fontWeight: 600,
                                                fontSize: '0.938rem',
                                                color: 'text.primary'
                                              }}
                                            >
                                              {sub.name}
                                            </Typography>
                                            {showArabic && sub.nameAr && (
                                              <Typography variant="caption" sx={{ color: 'text.secondary', fontStyle: 'italic', direction: 'rtl' }}>
                                                {sub.nameAr}
                                              </Typography>
                                            )}
                                          </Box>
                                          <Box 
                                            sx={{ 
                                              display: 'flex',
                                              gap: 0.5,
                                              width: { xs: '100%', sm: 'auto' },
                                              alignItems: 'center',
                                              flexWrap: 'wrap'
                                            }}
                                          >
                                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
                                              <IconButton
                                                size="small"
                                                aria-label="Move subcategory up"
                                                disabled={subIndex === 0}
                                                onClick={() => moveSubCategory(catIndex, subIndex, -1)}
                                                sx={{ p: 0.25 }}
                                              >
                                                <ArrowUpwardIcon sx={{ fontSize: 18 }} />
                                              </IconButton>
                                              <IconButton
                                                size="small"
                                                aria-label="Move subcategory down"
                                                disabled={subIndex >= subCategories.length - 1}
                                                onClick={() => moveSubCategory(catIndex, subIndex, 1)}
                                                sx={{ p: 0.25 }}
                                              >
                                                <ArrowDownwardIcon sx={{ fontSize: 18 }} />
                                              </IconButton>
                                            </Box>
                                            <Button
                                              size="small"
                                              variant={isSubExpanded ? 'contained' : 'outlined'}
                                              onClick={() => toggleItems(subIndex)}
                                              sx={{ 
                                                flexGrow: { xs: 1, sm: 0 },
                                                fontSize: '0.75rem',
                                                textTransform: 'none',
                                                borderRadius: 1,
                                                px: 1.5,
                                                fontWeight: 600
                                              }}
                                            >
                                              {isSubExpanded ? 'Hide Items' : 'Add Items'}
                                            </Button>
                                            <IconButton 
                                              size="small" 
                                              color="primary" 
                                              onClick={() => openEditSubCategory(catIndex, subIndex)}
                                              sx={{
                                                bgcolor: 'primary.lighter',
                                                '&:hover': {
                                                  bgcolor: 'primary.light'
                                                }
                                              }}
                                            >
                                              <EditIcon fontSize="small" />
                                            </IconButton>
                                            <IconButton 
                                              size="small" 
                                              color="error" 
                                              onClick={() => deleteSubCategory(catIndex, subIndex)}
                                              sx={{
                                                bgcolor: 'error.lighter',
                                                '&:hover': {
                                                  bgcolor: 'error.light'
                                                }
                                              }}
                                            >
                                              <DeleteIcon fontSize="small" />
                                            </IconButton>
                                          </Box>
                                        </Box>

                                        {/* Items section */}
                                        {isSubExpanded && (
                                          <Box 
                                            sx={{ 
                                              pt: 2,
                                              borderTop: '1px dashed',
                                              borderColor: 'grey.300',
                                              bgcolor: 'grey.50',
                                              p: { xs: 1.5, sm: 2 },
                                              borderRadius: 1,
                                              mt: 1
                                            }}
                                          >
                                            <Typography 
                                              variant="caption" 
                                              display="block" 
                                              gutterBottom
                                              sx={{ 
                                                fontWeight: 600,
                                                fontSize: '0.813rem',
                                                color: 'text.secondary',
                                                mb: 1.5
                                              }}
                                            >
                                              Add Item Details
                                            </Typography>
                                            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr', gap: 1.5, mb: 2 }}>
                                              <Box sx={{ display: 'grid', gridTemplateColumns: isArabicOnly ? '1fr' : showArabic ? '1fr 1fr' : '1fr', gap: 1.5 }}>
                                                {!isArabicOnly && <TextField label="Title (English)" size="small" value={itemTitle} onChange={(e) => setItemTitle(e.target.value)} sx={{ bgcolor: 'white', '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }} />}
                                                {(showArabic || isArabicOnly) && <TextField label={isArabicOnly ? 'العنوان' : 'العنوان (عربي)'} size="small" value={itemTitleAr} onChange={(e) => setItemTitleAr(e.target.value)} sx={{ bgcolor: 'white', '& .MuiOutlinedInput-root': { borderRadius: 1.5 }, direction: 'rtl' }} inputProps={{ dir: 'rtl' }} />}
                                              </Box>
                                              <Box sx={{ display: 'grid', gridTemplateColumns: isArabicOnly ? '1fr' : showArabic ? '1fr 1fr' : '1fr', gap: 1.5 }}>
                                                {!isArabicOnly && <TextField label="Description (English)" size="small" multiline rows={2} value={itemDesc} onChange={(e) => setItemDesc(e.target.value)} sx={{ bgcolor: 'white', '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }} />}
                                                {(showArabic || isArabicOnly) && <TextField label={isArabicOnly ? 'الوصف' : 'الوصف (عربي)'} size="small" multiline rows={2} value={itemDescAr} onChange={(e) => setItemDescAr(e.target.value)} sx={{ bgcolor: 'white', '& .MuiOutlinedInput-root': { borderRadius: 1.5 }, direction: 'rtl' }} inputProps={{ dir: 'rtl' }} />}
                                              </Box>
                                              <TextField label="Price" size="small" type="number" value={itemPrice} onChange={(e) => setItemPrice(e.target.value)} sx={{ bgcolor: 'white', '& .MuiOutlinedInput-root': { borderRadius: 1.5 } }} />
                                            </Box>
                                            <Button 
                                              size="small" 
                                              variant="contained" 
                                              color="success"
                                              startIcon={<AddIcon />} 
                                              onClick={() => addItem(catIndex, subIndex)}
                                              fullWidth
                                              sx={{
                                                textTransform: 'none',
                                                borderRadius: 1.5,
                                                py: 1,
                                                fontWeight: 600,
                                                fontSize: '0.875rem'
                                              }}
                                            >
                                              Add Item
                                            </Button>

                                            {/* Items list */}
                                            {items.length > 0 && (
                                              <Box sx={{ mt: 2 }}>
                                                <Typography 
                                                  variant="caption" 
                                                  sx={{ 
                                                    fontWeight: 600,
                                                    fontSize: '0.813rem',
                                                    color: 'text.secondary',
                                                    display: 'block',
                                                    mb: 1
                                                  }}
                                                >
                                                  Items List
                                                </Typography>
                                                <List dense disablePadding>
                                                  {items.map((item, itemIndex) => (
                                                    <ListItem 
                                                      key={itemIndex} 
                                                      sx={{ 
                                                        border: '1px solid',
                                                        borderColor: 'grey.300',
                                                        borderRadius: 1.5,
                                                        mb: 1,
                                                        bgcolor: 'white',
                                                        p: 1.5,
                                                        display: 'flex',
                                                        alignItems: 'flex-start',
                                                        flexDirection: { xs: 'column', sm: 'row' },
                                                        gap: 1
                                                      }}
                                                    >
                                                      <Box sx={{ flexGrow: 1, m: 0 }}>
                                                        <ListItemText
                                                          primary={item.name || item.title}
                                                          secondary={`${item.desc || 'No description'} • $${item.price || '0'}`}
                                                          sx={{
                                                            m: 0,
                                                            '& .MuiListItemText-primary': {
                                                              fontWeight: 600,
                                                              fontSize: '0.875rem',
                                                              mb: 0.5
                                                            },
                                                            '& .MuiListItemText-secondary': {
                                                              fontSize: '0.75rem'
                                                            }
                                                          }}
                                                        />
                                                        {showArabic && (item.nameAr || item.titleAr || item.descAr) && (
                                                          <Typography variant="caption" sx={{ color: 'text.secondary', fontStyle: 'italic', direction: 'rtl', display: 'block' }}>
                                                            {[item.nameAr, item.titleAr].filter(Boolean).join(' — ')}
                                                            {item.descAr ? ` • ${item.descAr}` : ''}
                                                          </Typography>
                                                        )}
                                                      </Box>
                                                      <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center', flexShrink: 0 }}>
                                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                                                          <IconButton
                                                            size="small"
                                                            aria-label="Move item up"
                                                            disabled={itemIndex === 0}
                                                            onClick={() => moveSubCategoryItem(catIndex, subIndex, itemIndex, -1)}
                                                            sx={{ p: 0.25 }}
                                                          >
                                                            <ArrowUpwardIcon sx={{ fontSize: 16 }} />
                                                          </IconButton>
                                                          <IconButton
                                                            size="small"
                                                            aria-label="Move item down"
                                                            disabled={itemIndex >= items.length - 1}
                                                            onClick={() => moveSubCategoryItem(catIndex, subIndex, itemIndex, 1)}
                                                            sx={{ p: 0.25 }}
                                                          >
                                                            <ArrowDownwardIcon sx={{ fontSize: 16 }} />
                                                          </IconButton>
                                                        </Box>
                                                        <IconButton 
                                                          size="small" 
                                                          color="primary" 
                                                          onClick={() => openEditItem(catIndex, subIndex, itemIndex)}
                                                          sx={{
                                                            bgcolor: 'primary.lighter',
                                                            '&:hover': {
                                                              bgcolor: 'primary.light'
                                                            }
                                                          }}
                                                        >
                                                          <EditIcon fontSize="small" />
                                                        </IconButton>
                                                        <IconButton 
                                                          size="small" 
                                                          color="error" 
                                                          onClick={() => deleteItem(catIndex, subIndex, itemIndex)}
                                                          sx={{
                                                            bgcolor: 'error.lighter',
                                                            '&:hover': {
                                                              bgcolor: 'error.light'
                                                            }
                                                          }}
                                                        >
                                                          <DeleteIcon fontSize="small" />
                                                        </IconButton>
                                                      </Box>
                                                    </ListItem>
                                                  ))}
                                                </List>
                                              </Box>
                                            )}
                                            {items.length === 0 && (
                                              <Typography 
                                                variant="caption" 
                                                color="text.secondary"
                                                sx={{ 
                                                  display: 'block',
                                                  textAlign: 'center',
                                                  py: 2,
                                                  fontStyle: 'italic'
                                                }}
                                              >
                                                No items yet
                                              </Typography>
                                            )}
                                          </Box>
                                        )}
                                      </CardContent>
                                    </Card>
                                  );
                                })}
                              </List>
                            )}
                            {subCategories.length === 0 && (
                              <Typography 
                                variant="body2" 
                                color="text.secondary"
                                sx={{ 
                                  textAlign: 'center',
                                  py: 2,
                                  fontStyle: 'italic'
                                }}
                              >
                                No subcategories yet
                              </Typography>
                            )}
                          </Box>
                        )}
                      </CardContent>
                    </Card>
                  );
                })}
              </List>
            )}
            {categories.length === 0 && (
              <Box 
                sx={{ 
                  textAlign: 'center',
                  py: 4,
                  px: 2,
                  bgcolor: 'grey.50',
                  borderRadius: 2,
                  border: '2px dashed',
                  borderColor: 'grey.300'
                }}
              >
                <Typography 
                  variant="body2" 
                  color="text.secondary"
                  sx={{ fontStyle: 'italic' }}
                >
                  No categories yet. Add your first category above to get started!
                </Typography>
              </Box>
            )}
          </CardContent>
        </Card>

        {/* Edit Category Dialog */}
        <Dialog open={editCategoryDialog} onClose={() => setEditCategoryDialog(false)} maxWidth="sm" fullWidth>
          <DialogTitle>Edit Category</DialogTitle>
          <DialogContent>
            <Box sx={{ pt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
              {!isArabicOnly && (
                <TextField
                  label="Category Name (English)"
                  variant="outlined"
                  fullWidth
                  value={editCategoryName}
                  onChange={(e) => setEditCategoryName(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && saveEditCategory()}
                  autoFocus
                />
              )}
              {(showArabic || isArabicOnly) && (
                <TextField
                  label={isArabicOnly ? 'اسم الفئة' : 'اسم الفئة (عربي)'}
                  variant="outlined"
                  fullWidth
                  value={editCategoryNameAr}
                  onChange={(e) => setEditCategoryNameAr(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && saveEditCategory()}
                  sx={{ direction: 'rtl' }}
                  inputProps={{ dir: 'rtl' }}
                  autoFocus={isArabicOnly}
                />
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setEditCategoryDialog(false)}>Cancel</Button>
            <Button onClick={saveEditCategory} variant="contained" color="primary">
              Save
            </Button>
          </DialogActions>
        </Dialog>

        {/* Edit Subcategory Dialog */}
        <Dialog open={editSubDialog} onClose={() => setEditSubDialog(false)} maxWidth="sm" fullWidth>
          <DialogTitle>Edit Subcategory</DialogTitle>
          <DialogContent>
            <Box sx={{ pt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
              {!isArabicOnly && (
                <TextField
                  label="Subcategory Name (English)"
                  variant="outlined"
                  fullWidth
                  value={editSubCategoryName}
                  onChange={(e) => setEditSubCategoryName(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && saveEditSubCategory()}
                  autoFocus
                />
              )}
              {(showArabic || isArabicOnly) && (
                <TextField
                  label={isArabicOnly ? 'اسم الفئة الفرعية' : 'اسم الفئة الفرعية (عربي)'}
                  variant="outlined"
                  fullWidth
                  value={editSubCategoryNameAr}
                  onChange={(e) => setEditSubCategoryNameAr(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && saveEditSubCategory()}
                  sx={{ direction: 'rtl' }}
                  inputProps={{ dir: 'rtl' }}
                  autoFocus={isArabicOnly}
                />
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setEditSubDialog(false)}>Cancel</Button>
            <Button onClick={saveEditSubCategory} variant="contained" color="primary">
              Save
            </Button>
          </DialogActions>
        </Dialog>

        {/* Edit Item Dialog */}
        <Dialog open={editItemDialog} onClose={() => setEditItemDialog(false)} maxWidth="md" fullWidth>
          <DialogTitle>Edit Item</DialogTitle>
          <DialogContent>
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' }, gap: 2, pt: 2 }}>
              {!isArabicOnly && (
                <TextField
                  label="Title (English)"
                  variant="outlined"
                  fullWidth
                  value={editItemTitle}
                  onChange={(e) => setEditItemTitle(e.target.value)}
                  autoFocus
                />
              )}
              {(showArabic || isArabicOnly) && (
                <TextField
                  label={isArabicOnly ? 'العنوان' : 'العنوان (عربي)'}
                  variant="outlined"
                  fullWidth
                  value={editItemTitleAr}
                  onChange={(e) => setEditItemTitleAr(e.target.value)}
                  sx={{ direction: 'rtl' }}
                  inputProps={{ dir: 'rtl' }}
                  autoFocus={isArabicOnly}
                />
              )}
              {!isArabicOnly && (
                <TextField
                  label="Description (English)"
                  variant="outlined"
                  fullWidth
                  multiline
                  rows={3}
                  value={editItemDesc}
                  onChange={(e) => setEditItemDesc(e.target.value)}
                  sx={{ gridColumn: { xs: '1', sm: 'span 2' } }}
                />
              )}
              {(showArabic || isArabicOnly) && (
                <TextField
                  label={isArabicOnly ? 'الوصف' : 'الوصف (عربي)'}
                  variant="outlined"
                  fullWidth
                  multiline
                  rows={3}
                  value={editItemDescAr}
                  onChange={(e) => setEditItemDescAr(e.target.value)}
                  sx={{ gridColumn: { xs: '1', sm: 'span 2' }, direction: 'rtl' }}
                  inputProps={{ dir: 'rtl' }}
                />
              )}
              <TextField
                label="Price"
                variant="outlined"
                fullWidth
                type="number"
                value={editItemPrice}
                onChange={(e) => setEditItemPrice(e.target.value)}
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setEditItemDialog(false)}>Cancel</Button>
            <Button onClick={saveEditItem} variant="contained" color="primary">
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </>
  );
};

export default EditResturnt;
